// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_DETAIL_HIDE_IMAGES = "Skry fotky";
export const BZ2_DETAIL_SHOW_ALL_IMAGES = "Zobraz v\u0161etky fotky";
